import * as icons from "lucide-react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const CATEGORY_LABEL = {
  cashback: "Cashback",
  "reward-apps": "Reward App",
  "card-tools": "Card Tool",
  surveys: "Survey Panel",
};

export default function ServiceCard({ service, index = 0 }) {
  const Icon = icons[toPascal(service.icon)] || icons.Sparkles;
  return (
    <Link
      to={`/service/${service.slug}`}
      className="mds-card block relative group"
      data-testid={`service-card-${service.slug}`}
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="mds-fade-up">
        <div className="flex items-start justify-between mb-4">
          <span
            className="w-11 h-11 rounded-xl grid place-items-center"
            style={{ background: "rgba(132,169,140,0.15)", color: "#6B8F73" }}
          >
            <Icon size={22} strokeWidth={1.6} />
          </span>
          <span className="mds-badge">{CATEGORY_LABEL[service.category] || service.category}</span>
        </div>
        <h3 className="font-heading font-semibold text-xl mb-2 group-hover:text-[#6B8F73] transition-colors">
          {service.name}
        </h3>
        <p className="text-[#4A5D54] text-sm leading-relaxed line-clamp-3">{service.tagline}</p>
        <div className="mt-6 flex items-center justify-between">
          <div>
            <div className="text-xs uppercase tracking-wide text-[#7A8C84]">avg / month</div>
            <div className="font-num font-semibold text-xl text-[#1C2321]">
              £{service.average_monthly_earning?.toFixed(0) ?? 0}
            </div>
          </div>
          <span
            className="w-9 h-9 rounded-full grid place-items-center border border-[#E5E3DB] text-[#4A5D54] group-hover:bg-[#84A98C] group-hover:text-white group-hover:border-transparent transition-all"
            aria-hidden
          >
            <ArrowUpRight size={16} />
          </span>
        </div>
      </div>
    </Link>
  );
}

function toPascal(s = "") {
  return s
    .split(/[-_ ]/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join("");
}
